function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".lamp{fill:#ee3f5c;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.384 11.233)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "lamp",
  d: "M228.721,271.341H217.144a1.3,1.3,0,0,1-1.3-1.3c0-4.824-1.971-9.042-6.2-13.274a18.8,18.8,0,1,1,26.591,0c-4.232,4.232-6.2,8.45-6.2,13.274A1.3,1.3,0,0,1,228.721,271.341ZM218.4,268.735h9.059a18.794,18.794,0,0,1,2.076-7.387,25.967,25.967,0,0,1,4.846-6.428,16.2,16.2,0,1,0-22.905,0,25.941,25.941,0,0,1,4.846,6.428A18.79,18.79,0,0,1,218.4,268.735Z",
  transform: "translate(-204.13 -224.665)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(25.573 9.426)"
}, /*#__PURE__*/React.createElement("path", {
  className: "lamp",
  d: "M301.781,278.932a1.3,1.3,0,0,1-.922-2.225,10.126,10.126,0,0,0,0-14.3,1.3,1.3,0,0,1,1.843-1.843,12.735,12.735,0,0,1,0,17.99A1.3,1.3,0,0,1,301.781,278.932Z",
  transform: "translate(-300.477 -260.179)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.711 50.729)"
}, /*#__PURE__*/React.createElement("path", {
  className: "lamp",
  d: "M261.132,418.395H249.554a1.3,1.3,0,1,1,0-2.606h11.577a1.3,1.3,0,1,1,0,2.606Z",
  transform: "translate(-248.251 -415.788)"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(24.883)"
}, /*#__PURE__*/React.createElement("path", {
  className: "lamp",
  d: "M271.364,190.681a1.3,1.3,0,0,1-1.3-1.3v-5.73a1.3,1.3,0,0,1,2.607,0v5.73A1.3,1.3,0,0,1,271.364,190.681Z",
  transform: "translate(-270.06 -182.345)"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.517 3.849)"
}, /*#__PURE__*/React.createElement("path", {
  className: "lamp",
  d: "M220.1,204.416a1.3,1.3,0,0,1-1.13-.652l-2.865-4.962a1.3,1.3,0,0,1,2.257-1.3l2.865,4.962a1.3,1.3,0,0,1-1.128,1.955Z",
  transform: "translate(-215.934 -196.847)"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 14.366)"
}, /*#__PURE__*/React.createElement("path", {
  className: "lamp",
  d: "M182.576,241.941a1.294,1.294,0,0,1-.65-.175l-4.962-2.865a1.3,1.3,0,0,1,1.3-2.257l4.962,2.865a1.3,1.3,0,0,1-.653,2.432Z",
  transform: "translate(-176.312 -236.469)"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(36.385 3.849)"
}, /*#__PURE__*/React.createElement("path", {
  className: "lamp",
  d: "M314.694,204.416a1.3,1.3,0,0,1-1.127-1.955l2.865-4.962a1.3,1.3,0,1,1,2.257,1.3l-2.865,4.962A1.3,1.3,0,0,1,314.694,204.416Z",
  transform: "translate(-313.392 -196.847)"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(44.804 14.366)"
}, /*#__PURE__*/React.createElement("path", {
  className: "lamp",
  d: "M346.417,241.941a1.3,1.3,0,0,1-.653-2.432l4.962-2.865a1.3,1.3,0,0,1,1.3,2.257l-4.962,2.865A1.3,1.3,0,0,1,346.417,241.941Z",
  transform: "translate(-345.112 -236.469)"
}));

function SvgLamp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.373,
    height: 64.568,
    viewBox: "0 0 52.373 64.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/Lamp.7ec46b4a.svg";
export { ForwardRef as ReactComponent };